
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { theme } from "../../../../../../../helpers/theme";


interface UnderlinedRedirectProps {
    text: string;
    url: string;
}
export const UnderlinedRedirect = ({ text, url }: UnderlinedRedirectProps) => {
    let navigate = useNavigate();
    return (
        <UnderlinedRedirectWrapper onClick={() => navigate(url)}>
            <Underlined>
                {text}
            </Underlined>
        </UnderlinedRedirectWrapper >

    );
};

const UnderlinedRedirectWrapper = styled.button`
display:flex;
flex-direction:column;
justyf-content:center;
margin-right:auto;
margin-left:auto;
border: none;
align-items: center;
overflow-wrap: break-word;
background-color: transparent;
cursor: pointer;
margin-top:32px;
margin-bottom:177px;

`;
const Underlined = styled.div`
font-family:  ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
text-align: center;
text-decoration-line: underline;
color:  ${theme.colors.black_primaryText};
`